import {combineReducers} from '@reduxjs/toolkit';
import filReports from "./filter-reports.slice";
import paymentReports from "./payment-reports-list.slice";

const reducer = combineReducers({
  filReports,
  paymentReports
});

export default reducer;